"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importStar(require("../../../../theme/styled-components"));

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n"])));
var InnerWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  justify-items: center;\n  align-items: center;\n  margin: auto;\n"], ["\n  display: grid;\n  justify-items: center;\n  align-items: center;\n  margin: auto;\n"])));
var Item = styled_components_1["default"].a(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  grid-column: 1;\n  grid-row: 1;\n  ", ";\n  transition: opacity 500ms ease-in-out;\n  pointer-events: none;\n  opacity: 0;\n  position: relative;\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  grid-column: 1;\n  grid-row: 1;\n  ", ";\n  transition: opacity 500ms ease-in-out;\n  pointer-events: none;\n  opacity: 0;\n  position: relative;\n  ", ";\n  ", ";\n"])), function (_a) {
  var maxWidth = _a.maxWidth;
  return maxWidth && styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), maxWidth);
}, function (_a) {
  var fadeIn = _a.fadeIn;
  return fadeIn && styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      pointer-events: auto;\n      opacity: 1;\n      z-index: 2;\n    "], ["\n      pointer-events: auto;\n      opacity: 1;\n      z-index: 2;\n    "])));
}, function (_a) {
  var fadeOut = _a.fadeOut;
  return fadeOut && styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      pointer-events: none;\n      opacity: 0;\n      z-index: 1;\n    "], ["\n      pointer-events: none;\n      opacity: 0;\n      z-index: 1;\n    "])));
});
var StyledMediaManagerImage = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var maxHeight = _a.maxHeight;
  return maxHeight && styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      max-height: ", "px;\n    "], ["\n      max-height: ", "px;\n    "])), maxHeight);
});

var getRandomInt = function (min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
};

var getRandomIndex = function (numberOfItems, currentIndex) {
  var result = getRandomInt(0, numberOfItems);

  while (result === currentIndex) {
    result = getRandomInt(0, numberOfItems);
  }

  return result;
};

var getNextIndex = function (numberOfItems, currentIndex) {
  return (currentIndex + 1) % numberOfItems;
};

var SingleRotation = function (_a) {
  var width = _a.width,
      items = _a.items,
      interval = _a.interval,
      randomOrder = _a.randomOrder;

  var _b = react_1["default"].useState([-1, 0]),
      activeIndexes = _b[0],
      setActiveIndexes = _b[1];

  react_1["default"].useEffect(function () {
    if (items.length < 2) {
      return;
    }

    var changeBanner = function () {
      setActiveIndexes(function (_a) {
        var currentIndex = _a[1];
        var nextIndex = randomOrder ? getRandomIndex(items.length, currentIndex) : getNextIndex(items.length, currentIndex);
        return [currentIndex, nextIndex];
      });
    };

    var intervalId = setInterval(changeBanner, interval);
    return function () {
      clearInterval(intervalId);
    };
  }, [interval, randomOrder, items.length]);
  return react_1["default"].createElement(Wrapper, null, react_1["default"].createElement(InnerWrapper, null, items.map(function (item, idx) {
    return react_1["default"].createElement(Item, {
      title: item.title,
      href: item.url || '#',
      key: idx,
      maxWidth: width,
      fadeIn: activeIndexes[1] === idx,
      fadeOut: activeIndexes[0] === idx
    }, react_1["default"].createElement(StyledMediaManagerImage, {
      picture: item.picture,
      alt: item.title,
      naturalWidth: width,
      naturalHeight: 0,
      maxHeight: width
    }));
  })));
};

exports["default"] = SingleRotation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;